import React from 'react'
import { useQuery } from 'react-query'
import { API_AUTH_TYPES, API_ROUTES, ApiRequest } from '../../../../api'
import { dateFormatterGmailTime } from '../../../../helpers/formatters'
import { classNames } from '../../../../helpers/classNames'
import useNav from '../../../../hooks/useNav'

const bunmailApi = new ApiRequest(API_ROUTES.BUNMAIL, API_AUTH_TYPES.ADVISOR)

const HouseholdEmails = ({ householdId, limit = 8 }) => {
    const nav = useNav()

    const { data: threadsResponse, isLoading } = useQuery({
        queryFn: () => bunmailApi.get({
            endpoint: 'index_threads',
            params: [1, true],
            queryParams: {
                label: `QUERY_household_${householdId}`,
                quick: true,
                limit
            }
        }),
        queryKey: ['household-bunmail-threads', householdId, limit]
    })

    const threads = React.useMemo(() => {
        if (!threadsResponse) return []
        if (Array.isArray(threadsResponse)) return threadsResponse
        if (threadsResponse.threads && Array.isArray(threadsResponse.threads)) return threadsResponse.threads
        return []
    }, [threadsResponse])

    const openThread = (threadId) => {
        const labelParam = encodeURIComponent(`QUERY_household_${householdId}`)
        nav(`/crm/emails/thread/${threadId}?label=${labelParam}`)
    }

    return (
        <div className="w-full">
            {isLoading && (
                <div className="text-sm text-gray-500">Loading emails…</div>
            )}
            {!isLoading && threads.length === 0 && (
                <div className="text-sm text-gray-500">No emails found for this household.</div>
            )}
            {!isLoading && threads.length > 0 && (
                <ul className="divide-y divide-gray-200">
                    {threads.slice(0, limit).map((thread) => {
                        const latest = thread.messages && thread.messages[0] ? thread.messages[0] : null
                        if (!latest) return null
                        return (
                            <li key={thread.thread_id}>
                                <button
                                    type="button"
                                    onClick={() => openThread(latest.thread_id)}
                                    className="w-full text-left px-2 py-3 hover:bg-gray-50 rounded-md"
                                >
                                    <div className="flex items-start justify-between">
                                        <div className="flex-1 min-w-0 pr-3">
                                            <p className={classNames(!latest.is_read ? 'font-semibold text-gray-900' : 'text-gray-900', 'truncate')}>
                                                {latest.subject || '(no subject)'}
                                            </p>
                                            <div className="mt-1 text-xs text-gray-600 space-y-0.5">
                                                <p className="truncate">From: {latest.from_name || latest.from_email || 'Unknown'}</p>
                                                <p className="truncate">To: {latest.to_email || 'Unknown'}</p>
                                                {latest.snippet && (
                                                    <p className="truncate text-gray-500">{latest.snippet}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex-shrink-0 text-xs text-gray-500">
                                            {latest.date && dateFormatterGmailTime(new Date(latest.date))}
                                        </div>
                                    </div>
                                </button>
                            </li>
                        )
                    })}
                </ul>
            )}
        </div>
    )
}

export default HouseholdEmails


